import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
	selector: 'app-double-monday-component',
	imports: [IonicModule],
	templateUrl: './double-monday-component.html',
	styleUrl: './double-monday-component.css',
})
export class DoubleMondayComponent {
	@Input() label: string | null = null;
}
